/**
 * Badge de color por valor de enum (estado, categoría, tipo). Entrada
 * `enum-badge` del catálogo: hasta hoy había 5 `Record<Enum, string> + <Badge>`
 * (inventory, performance ×2, partnerships, TA). Nace genérico con Owned Media;
 * las cinco copias se migran al tocarlas.
 */
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export type BadgeTone = 'neutral' | 'info' | 'success' | 'warning' | 'danger' | 'accent' | 'muted';

const TONE_CLASSES: Record<BadgeTone, string> = {
  neutral: 'bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-200 dark:border-slate-700',
  info: 'bg-sky-50 text-sky-800 border-sky-200 dark:bg-sky-950 dark:text-sky-200 dark:border-sky-800',
  success: 'bg-emerald-50 text-emerald-800 border-emerald-200 dark:bg-emerald-950 dark:text-emerald-200 dark:border-emerald-800',
  warning: 'bg-amber-50 text-amber-800 border-amber-200 dark:bg-amber-950 dark:text-amber-200 dark:border-amber-800',
  danger: 'bg-rose-50 text-rose-800 border-rose-200 dark:bg-rose-950 dark:text-rose-200 dark:border-rose-800',
  accent: 'bg-violet-50 text-violet-800 border-violet-200 dark:bg-violet-950 dark:text-violet-200 dark:border-violet-800',
  muted: 'bg-muted text-muted-foreground border-transparent',
};

export function EnumBadge({ value, tone = 'neutral', className, label }: { value: string; tone?: BadgeTone; className?: string; label?: string }) {
  return (
    <Badge variant="outline" className={cn('font-medium whitespace-nowrap', TONE_CLASSES[tone], className)}>
      {label ?? value}
    </Badge>
  );
}
